import script from "./PostCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./PostCard.vue?vue&type=script&lang=ts&setup=true"

import "./PostCard.vue?vue&type=style&index=0&id=1b578e6e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b578e6e"]])

export default __exports__